"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastContainer", {
    enumerable: true,
    get: function() {
        return ToastContainer;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToastContainer = require("./useToastContainer");
const _renderToastContainer = require("./renderToastContainer");
const _useToastContainerStylesstyles = require("./useToastContainerStyles.styles");
const _useToastContainerContextValues = require("./useToastContainerContextValues");
const ToastContainer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToastContainer.useToastContainer_unstable)(props, ref);
    (0, _useToastContainerStylesstyles.useToastContainerStyles_unstable)(state);
    return (0, _renderToastContainer.renderToastContainer_unstable)(state, (0, _useToastContainerContextValues.useToastContainerContextValues_unstable)(state));
});
ToastContainer.displayName = 'ToastContainer';
